import { render, staticRenderFns } from "./stockin_list.vue?vue&type=template&id=cdfbaacc&scoped=true"
import script from "./stockin_list.vue?vue&type=script&lang=js"
export * from "./stockin_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfbaacc",
  null
  
)

export default component.exports